export function formatDate(date, locale) {
    if (!date) {
        throw new Error("Invalid date");
    }
    const formatDate = new Date(Date.parse(date));
    return dateFormatter(formatDate, locale);
}
export function generateStartEndDate(datePeriod, locale) {
    const startDate = new Date();
    const addTime = datePeriod * 24 * 60 * 60 * 1000;
    let endDate = new Date(new Date().getTime() + addTime);
    return {
        startDate: dateFormatter(startDate, locale),
        endDate: dateFormatter(endDate, locale)
    };
}
export function dateFormatter(date, locale) {
    const language = locale.code;
    const country = locale.country;
    const localeStr = `${language}-${country}`;
    const timeZone = { timeZone: "Europe/Berlin" };
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        ...timeZone
    };
    return new Intl.DateTimeFormat(localeStr, options).format(date);
}
export function getDateTimeFormat(data, locale, options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
}) {
    const localeStr = `${locale.code}-${locale.country}`;
    const timeZone = { timeZone: "Europe/Berlin" };
    const opt = { ...options, ...timeZone };
    return new Intl.DateTimeFormat(localeStr, opt).format(data);
}
export function getDetailDate(date, locale) {
    if (!date) {
        return undefined;
    }
    var tmpDate = new Date(date);
    const returnDate = {
        date: formatDate(date, locale),
        dateDay: getDateTimeFormat(tmpDate, locale, { day: '2-digit' }),
        dateMonthFull: getDateTimeFormat(tmpDate, locale, { month: 'long' }),
        dateMonthAbbr: getDateTimeFormat(tmpDate, locale, { month: 'short' }),
    };
    return returnDate;
}
export function mapEventDateDetails(eventItem, locale) {
    const dateDetails = [];
    const language = locale.code;
    const country = locale.country;
    const startDate = new Date(eventItem?.date);
    const endDate = eventItem?.dateEnd ? new Date(eventItem?.dateEnd) : null;
    const localeStr = `${language}-${country}`;
    const timeZone = { timeZone: "Europe/Berlin" };
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        ...timeZone
    };
    function isValidDate(d) {
        return d instanceof Date && !isNaN(d.getTime());
    }
    function isDateEqual(date1, date2) {
        return date1.getTime() === date2.getTime();
    }
    if (isValidDate(startDate)) {
        const date1 = {
            date: new Intl.DateTimeFormat(localeStr, options).format(startDate),
            dateYear: new Intl.DateTimeFormat(localeStr, { ...timeZone, year: 'numeric' }).format(startDate),
            dateDay: new Intl.DateTimeFormat(localeStr, { ...timeZone, day: '2-digit' }).format(startDate),
            dateMonth: new Intl.DateTimeFormat(localeStr, { ...timeZone, month: '2-digit' }).format(startDate),
            dateMonthFull: new Intl.DateTimeFormat(localeStr, { ...timeZone, month: 'long' }).format(startDate),
            dateMonthAbbr: new Intl.DateTimeFormat(localeStr, { ...timeZone, month: 'short' }).format(startDate),
        };
        dateDetails.push(date1);
    }
    if (endDate !== null && isValidDate(endDate) && !isDateEqual(startDate, endDate)) {
        const date2 = {
            date: new Intl.DateTimeFormat(localeStr, options).format(endDate),
            dateYear: new Intl.DateTimeFormat(localeStr, { ...timeZone, year: 'numeric' }).format(endDate),
            dateDay: new Intl.DateTimeFormat(localeStr, { ...timeZone, day: '2-digit' }).format(endDate),
            dateMonth: new Intl.DateTimeFormat(localeStr, { ...timeZone, month: '2-digit' }).format(endDate),
            dateMonthFull: new Intl.DateTimeFormat(localeStr, { ...timeZone, month: 'long' }).format(endDate),
            dateMonthAbbr: new Intl.DateTimeFormat(localeStr, { ...timeZone, month: 'short' }).format(endDate),
        };
        dateDetails.push(date2);
    }
    return dateDetails;
}
